// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* cancelButton.css */

/* ========================================
   LOCAL TOKENS
   ======================================== */

:root {
  --scl--cms-components-cancelButton-icon-default: var(--input-defualt, #8A8B8F);
  --scl--cms-components-cancelButton-icon-hover:   var(--input-hover, rgba(0, 0, 0, 0.8));
}

/* ========================================
   BASE
   ======================================== */

.scl--cms-components-cancelButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  transition: color 0.15s ease;
  outline: none;
}

/* ========================================
   STATE: default
   ======================================== */

.scl--cms-components-cancelButton--default {
  color: var(--scl--cms-components-cancelButton-icon-default);
}

/* ========================================
   STATE: hover
   ======================================== */

.scl--cms-components-cancelButton--hover {
  color: var(--scl--cms-components-cancelButton-icon-hover);
}

/* ========================================
   STATE: disabled
   ======================================== */

.scl--cms-components-cancelButton--disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: var(--scl--cms-components-cancelButton-icon-default);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/button-fs-cp/cancel-button-op/css/cancelButton.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;;6CAE6C;;AAE7C;EACE,8EAA8E;EAC9E,uFAAuF;AACzF;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,aAAa;AACf;;AAEA;;6CAE6C;;AAE7C;EACE,2DAA2D;AAC7D;;AAEA;;6CAE6C;;AAE7C;EACE,yDAAyD;AAC3D;;AAEA;;6CAE6C;;AAE7C;EACE,YAAY;EACZ,mBAAmB;EACnB,2DAA2D;AAC7D","sourcesContent":["/* cancelButton.css */\n\n/* ========================================\n   LOCAL TOKENS\n   ======================================== */\n\n:root {\n  --scl--cms-components-cancelButton-icon-default: var(--input-defualt, #8A8B8F);\n  --scl--cms-components-cancelButton-icon-hover:   var(--input-hover, rgba(0, 0, 0, 0.8));\n}\n\n/* ========================================\n   BASE\n   ======================================== */\n\n.scl--cms-components-cancelButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: color 0.15s ease;\n  outline: none;\n}\n\n/* ========================================\n   STATE: default\n   ======================================== */\n\n.scl--cms-components-cancelButton--default {\n  color: var(--scl--cms-components-cancelButton-icon-default);\n}\n\n/* ========================================\n   STATE: hover\n   ======================================== */\n\n.scl--cms-components-cancelButton--hover {\n  color: var(--scl--cms-components-cancelButton-icon-hover);\n}\n\n/* ========================================\n   STATE: disabled\n   ======================================== */\n\n.scl--cms-components-cancelButton--disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  color: var(--scl--cms-components-cancelButton-icon-default);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
